var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 21,
    viewBox: "0 0 112 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9209 13.8877L17.696 20.8318H23.8413L11.9209 13.8877Z",
    fill: "#919191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9214 13.8877L11.8984 13.9012L0.000976562 20.8318H6.14622L11.9214 13.8877Z",
    fill: "#727272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9209 13.8877L14.426 20.8318H17.696L11.9209 13.8877Z",
    fill: "#828282"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9209 20.8318H14.426L11.9209 13.8877V20.8318Z",
    fill: "#828282"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41602 20.8318H11.9211V13.8877L9.41602 20.8318Z",
    fill: "#828282"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9206 13.8877L6.14551 20.8318H9.41557L11.9206 13.8877Z",
    fill: "#828282"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9209 13.8877L11.9374 13.8973L23.8415 20.8316L20.7687 15.4619L11.9209 13.8877Z",
    fill: "#D7D7D7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9209 13.8888L20.7687 15.463L19.1336 12.6055L11.9209 13.8888Z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9209 13.8881L19.1336 12.6048L17.8813 10.416L11.9209 13.8881Z",
    fill: "#E6E6E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8813 10.4163L16.6288 8.22754L11.9209 13.8884L17.8813 10.4163Z",
    fill: "#E6E6E6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9209 13.8884L16.6288 8.22761L14.9938 5.37012L11.9209 13.8884Z",
    fill: "#E6E6E6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9209 13.888L14.9938 5.36968L11.9209 0V13.888Z",
    fill: "#F6F6F6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9205 13.888V0L8.84766 5.36968L11.9205 13.888Z",
    fill: "#242424"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9206 13.8877L3.07288 15.4619L0 20.8316L11.9206 13.8877Z",
    fill: "#434343"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9208 13.8884L8.84792 5.37012L7.21289 8.22761L11.9208 13.8884Z",
    fill: "#333333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21347 8.22754L5.96094 10.4163L11.9214 13.8884L7.21347 8.22754Z",
    fill: "#333333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9207 13.8881L5.96029 10.416L4.70801 12.6048L11.9207 13.8881Z",
    fill: "#333333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.921 13.8888L4.70827 12.6055L3.07324 15.463L11.921 13.8888Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2721_84820",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 24,
    height: 22
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "difference"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9209 13.887L11.8979 13.9006L0.000516731 20.8312H6.14576L9.41583 20.8311H11.9209H14.426H17.696L23.8413 20.8312L12.3722 14.1499L23.8415 20.8309L20.7687 15.4612L19.1336 12.6037L17.8813 10.415L16.6288 8.22622V8.2262L14.9938 5.3687L11.9209 -0.000976562L8.84802 5.3687L11.9209 13.887L8.84801 5.36872L7.21297 8.22621L7.21298 8.22622L5.96044 10.415L4.70817 12.6037L3.07313 15.4612L0.000251967 20.8309L11.9209 13.887ZM0 20.8314V20.8312H0.00051619L0 20.8314Z",
    fill: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2721_84820)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -0.000976562,
    width: 23.6673,
    height: 20.8329,
    fill: "#DD5D26"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4248 3.65625V5.65256H33.4661V3.65625H31.4248ZM31.5535 7.36638V16.9713H33.3558V7.36638H31.5535Z",
    fill: "#FCFCFC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3609 16.9713H37.1632V11.0765C37.1632 9.62636 38.0091 8.66587 39.3516 8.66587C40.7309 8.66587 40.9883 9.53219 40.9883 10.8128V16.9713H42.7906V11.0765C42.7906 9.62636 43.6365 8.66587 44.979 8.66587C46.3583 8.66587 46.6158 9.53219 46.6158 10.8128V16.9713H48.418V10.3043C48.418 8.25154 47.4617 7.08388 45.5675 7.08388C44.1147 7.08388 43.1768 7.83721 42.4964 8.76003H42.4596C42.0734 7.68654 41.2826 7.08388 39.9769 7.08388C38.5608 7.08388 37.6965 7.83721 37.1999 8.5717H37.1632V7.36638H35.3609V16.9713Z",
    fill: "#FCFCFC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8974 17.2349C54.4238 17.2349 55.4904 16.6135 56.1157 15.6153H56.1525C56.2444 16.7076 56.7409 17.0654 57.6237 17.0654C57.9179 17.0654 58.2306 17.0278 58.5432 16.9524V15.8225C58.4329 15.8413 58.3777 15.8413 58.3225 15.8413C57.9731 15.8413 57.8811 15.4835 57.8811 14.7866V10.3797C57.8811 7.89371 56.3364 7.06505 54.4054 7.06505C51.5365 7.06505 50.3595 8.5152 50.2676 10.3608H52.1066C52.1985 9.08019 52.6951 8.55287 54.3318 8.55287C55.7111 8.55287 56.1157 9.13669 56.1157 9.83352C56.1157 10.7752 55.2145 10.9635 53.7433 11.246C51.4078 11.7168 49.8262 12.3383 49.8262 14.4853C49.8262 16.1238 51.0216 17.2349 52.8974 17.2349ZM53.302 15.7471C52.1801 15.7471 51.7204 15.2575 51.7204 14.3535C51.7204 13.3553 52.4008 12.9033 54.056 12.5455C55.0123 12.3383 55.8214 12.1312 56.1157 11.8487V13.2235C56.1157 14.8996 54.9203 15.7471 53.302 15.7471Z",
    fill: "#FCFCFC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5326 16.331C66.5326 18.1389 65.6499 18.9111 63.9396 18.9111C62.4132 18.9111 61.7695 18.2331 61.5856 17.3668H59.7282C59.9121 19.0994 61.2546 20.4177 63.9396 20.4177C66.6246 20.4177 68.3349 19.1183 68.3349 16.218V7.36638H66.5326V8.49637H66.4959C65.9809 7.81837 65.1166 7.08388 63.6086 7.08388C61.273 7.08388 59.4708 8.70353 59.4708 11.7922C59.4708 14.862 61.273 16.4816 63.6086 16.4816C65.1166 16.4816 65.9809 15.8036 66.4959 15.0315H66.5326V16.331ZM63.9396 8.6282C65.5579 8.6282 66.5142 9.68285 66.5142 11.7922C66.5142 13.8826 65.5579 14.9561 63.9396 14.9561C62.1741 14.9561 61.3466 13.6001 61.3466 11.7922C61.3466 9.98419 62.1741 8.6282 63.9396 8.6282Z",
    fill: "#FCFCFC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2348 3.65625V5.65256H72.2762V3.65625H70.2348ZM70.3636 7.36638V16.9713H72.1658V7.36638H70.3636Z",
    fill: "#FCFCFC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1709 16.9713H75.9732V11.0765C75.9732 9.62636 76.9663 8.66587 78.5111 8.66587C79.8535 8.66587 80.4053 9.53219 80.4053 10.8128V16.9713H82.2259V10.3043C82.2259 8.10087 80.8282 7.08388 79.0995 7.08388C77.4812 7.08388 76.5065 7.83721 76.01 8.5717H75.9732V7.36638H74.1709V16.9713Z",
    fill: "#FCFCFC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2783 17.2538C90.7426 17.2538 92.1219 15.8601 92.6 14.0145H90.7794C90.5955 14.6548 89.9702 15.7471 88.3151 15.7471C86.4577 15.7471 85.5382 14.2781 85.5014 12.6585H92.7104C92.7288 12.5078 92.7288 12.2253 92.7288 11.9617C92.7288 8.98603 91.1288 7.06505 88.2783 7.06505C85.4094 7.06505 83.644 9.13669 83.644 12.15C83.644 15.088 85.2991 17.2538 88.2783 17.2538ZM88.2231 8.5717C89.8231 8.5717 90.8346 9.70169 90.8346 11.2083H85.5014C85.6117 9.62636 86.7151 8.5717 88.2231 8.5717Z",
    fill: "#FCFCFC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4023 14.9185V16.9713H95.4069V14.9185H93.4023Z",
    fill: "#FCFCFC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7485 3.65625V5.65256H99.7898V3.65625H97.7485ZM97.8772 7.36638V16.9713H99.6795V7.36638H97.8772Z",
    fill: "#FCFCFC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M105.862 17.2538C108.786 17.2538 110.551 15.1633 110.551 12.15C110.551 9.15553 108.786 7.06505 105.862 7.06505C102.938 7.06505 101.172 9.17436 101.172 12.1688C101.172 15.1821 102.938 17.2538 105.862 17.2538ZM105.862 15.7283C103.931 15.7283 103.048 14.1651 103.048 12.1688C103.048 10.1537 103.931 8.60937 105.862 8.60937C107.774 8.60937 108.675 10.1537 108.675 12.1688C108.675 14.1651 107.774 15.7283 105.862 15.7283Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/Logo-Light.b5f836b62ba00db73a19275b6fb17a7e.svg";
export { ForwardRef as ReactComponent };